// Pages only some builds have. .github/workflows/deploy-ann.yml seds the line below to false for
// Ann - keep it verbatim.

// Bank Receipts (Fitfood's Mattermost channel bankreceipt): the nav link and the /bankreceipt route
export const BANK_RECEIPTS_ON = false
